import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=4203c692&scoped=true&"
import script from "./SearchPage.vue?vue&type=script&lang=js&"
export * from "./SearchPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=4203c692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203c692",
  null
  
)

export default component.exports